/* eslint-disable no-undef */
((window, document) => {
  // -- Determine which site we're on --
  const host = window.location.host.toLowerCase();
  const isTTC = /ttc|thetaxicentre/.test(host);
  const isVD = /vd|vansdirect/.test(host);

  /**
   * Determine whether the dealership is open now
   * @method isDealershipOpen
   * @param {array} openingTimes
   * @returns {boolean}
   */
  async function isDealershipOpen(openingTimes) {
    const now = new Date();
    const openingTime = new Date();
    const closingTime = new Date();
    const todayHours = openingTimes[now.getDay()];
    if (todayHours[0] === 'Closed') {
      return false;
    }
    const [openHour, openMinute] = todayHours[0].split(':').map(Number);
    const [closeHour, closeMinute] = todayHours[1].split(':').map(Number);
    openingTime.setHours(openHour, openMinute);
    closingTime.setHours(closeHour, closeMinute);
    return now > openingTime && now < closingTime;
  }

  /**
   * Show 'open' or 'closed' display based on opening times
   * @method updateDealershipStatus
   * @param {array} openingTimes
   */
  async function updateDealershipStatus(openingTimes) {
    const dealershipOpen = await isDealershipOpen(openingTimes);
    document
      .querySelector('.opening-hours--open')
      .classList.toggle('hide__default', !dealershipOpen);
    document
      .querySelector('.opening-hours--closed')
      .classList.toggle('hide__default', dealershipOpen);
  }

  /**
   * Convert 24hr time string into 12hr time string
   * @method processTime
   * @param {string} time
   * @returns {string}
   */
  function processTime(time) {
    if (time === 'Closed' || typeof time === 'undefined') {
      return 'Closed';
    }
    let [hours, minutes] = time.split(':').map(Number);
    hours = hours > 12 ? hours - 12 : hours;
    minutes = minutes === 0 ? '00' : minutes;
    return `${hours}:${minutes}`;
  }

  /**
   * Populate the tooltip text based on opening hours
   * @method populateTooltip
   * @param {array} openingTimes
   */
  function populateTooltip(openingTimes) {
    const weekdays = `${processTime(openingTimes[1][0])}am - ${processTime(
      openingTimes[1][1],
    )}pm Monday to Friday`;
    const saturday =
      processTime(openingTimes[6][0]) === 'Closed'
        ? 'Closed on Saturday'
        : `${processTime(openingTimes[6][0])}am - ${processTime(openingTimes[6][1])}pm on Saturday`;
    const sunday =
      processTime(openingTimes[0][0]) === 'Closed'
        ? 'Closed on Sunday'
        : `${processTime(openingTimes[0][0])}am - ${processTime(openingTimes[0][1])}pm on Sunday`;
    const toolTipText = `
        ${weekdays}<br />
        ${saturday}<br />
        ${sunday}
        `;
    let toolTips = document.querySelectorAll('.js-openingHours');
    toolTips = [...toolTips];
    toolTips.forEach((element) => {
      element.innerHTML = toolTipText;
    });
  }

  /**
   * Get the dealership opening times from progress/VertuCentral
   * @method getOpeningTimes
   * @param {number} locationRef
   * @returns {array}
   */
  async function getOpeningTimes(locationRef) {
    const response = await fetch(`/content/api/json_dealer.p?locnref=${locationRef}`);
    let data = await response.json();
    const opening = [];
    data = data.locationDetail.openingTimes[0].openDays;
    data.unshift(data.pop());
    data.forEach((day) => {
      opening.push(day.openTimes.split(' - '));
    });
    return opening;
  }

  /**
   * Initialise the script
   * @method initialise
   */
  async function initialise() {
    let dealershipLocRef;
    if (isVD) {
      dealershipLocRef = 325;
    } else if (isTTC) {
      dealershipLocRef = 243;
    }
    const data = await getOpeningTimes(dealershipLocRef);
    updateDealershipStatus(data);
    if (isVD) {
      populateTooltip(data);
    }
  }

  window.onload = initialise();
})(window, document);
